import "./style.css";

export const BtnSubmit = ({ className, isSubmitting, text = "Salvar" }) => {
	return (
		<button type="submit" className={`btn btn-success btn-submit ${className}`} disabled={isSubmitting}>
			{!isSubmitting ? (
				text
			) : (
				<>
					Salvando
					<div>
						<span
							className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
							role="status"
						></span>
						<span
							className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
							role="status"
						></span>
					</div>
				</>
			)}
		</button>
	);
};

// export const BtnSubmit = (props) => {
// 	const isSubmitting = props.isSubmitting;

// 	return (
// 		<button type="submit" className="btn btn-success btn-submit" disabled={isSubmitting}>
// 			{!isSubmitting ? (
// 				"Salvar"
// 			) : (
// 				<>
// 					Salvando
// 					<div>
// 						<span className="spinner-grow custom-spinner spinner-grow-sm text-color me-2" role="status"></span>
// 						<span className="spinner-grow custom-spinner spinner-grow-sm text-color me-2" role="status"></span>
// 					</div>
// 				</>
// 			)}
// 		</button>
// 	);
// };
